export default __webpack_public_path__ + "static/media/carousel-1.df528886.jpg";